module.exports = __webpack_public_path__ + "img/case_internet_company.23e3c21f.png";